import React from "react";

import { HeaderNSidebar } from "components/template/HeaderNSidebar";
import { APIConnect } from "components/template/Product/APIConnect";

import "./APIConnectPage.scss";

export const APIConnectPage = () => {
  return (
    <HeaderNSidebar cx={"APIConnectPage"}>
      <main>
        <APIConnect />
      </main>
    </HeaderNSidebar>
  );
};
